
import { css } from 'lit';
export default css`
:host {
  display: block;
}

.hf-image-placemat-cta {
  display: flex;
  width: 100%;
  flex-direction: column;
  min-height: 469px;
}

.hf-image-placemat-cta__wrapper {
  display: flex;
}

.hf-image-placemat-cta__wrapper {
  width: 100%;
}

.hf-image-placemat-cta__wrapper {
  align-items: center;
}

.hf-image-placemat-cta__wrapper {
  justify-content: center;
}

.hf-image-placemat-cta__wrapper {
  background-size: cover;
}

.hf-image-placemat-cta__wrapper {
  background-position: center;
}

.hf-image-placemat-cta__wrapper {
  background-repeat: no-repeat;
}

.hf-image-placemat-cta__wrapper {
    background-image: var(--placemat-mobile-bg-image);
  }

@media (min-width: 1024px) {

.hf-image-placemat-cta__wrapper {
      background-image: var(--placemat-bg-image)
  }
    }

.hf-image-placemat-cta__card {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.hf-image-placemat-cta__card {
  margin-left: 3rem;
  margin-right: 3rem;
}

.hf-image-placemat-cta__card {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.hf-image-placemat-cta--single .hf-image-placemat-cta__wrapper {
  justify-content: flex-start;
}

@media (min-width: 1024px) {

  .hf-image-placemat-cta {
    flex-direction: row;
  }
}

@media (min-width: 1024px) {

  .hf-image-placemat-cta .hf-image-placemat-cta--single .hf-image-placemat-cta__wrapper {
    justify-content: center;
  }
}

@media (min-width: 1024px) {

  .hf-image-placemat-cta .hf-image-placemat-cta--single .hf-image-placemat-cta__card {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
}

@media (min-width: 1024px) {

  .hf-image-placemat-cta .hf-image-placemat-cta--single .hf-image-placemat-cta__card {
    margin-right: 7rem;
  }
}

@media (min-width: 1024px) {

  .hf-image-placemat-cta .hf-image-placemat-cta--single .hf-image-placemat-cta__card {
    margin-left: 10rem;
  }
}

@media (min-width: 1200px) {

  .hf-image-placemat-cta .hf-image-placemat-cta__card {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
}

@media (min-width: 1200px) {

  .hf-image-placemat-cta .hf-image-placemat-cta__card {
    margin-left: 6rem;
    margin-right: 6rem;
  }
}
`;